import { Component } from '@angular/core';
import { MasterComponent, MasterDetailComponent } from '@rocksoft/cdk';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { DevicesOverviewComponent } from './devices-overview.component';

@Component({
  selector: 'ml-mdm-devices',
  templateUrl: './devices.component.html',
  imports: [MasterDetailComponent, MasterComponent, DevicesOverviewComponent],
})
export class DevicesComponent {
  public readonly features: EnvironmentFeatures;
}
